var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "list-group",
          on: {
            start: function($event) {
              _vm.dragging = true
            }
          },
          model: {
            value: _vm.items,
            callback: function($$v) {
              _vm.items = $$v
            },
            expression: "items"
          }
        },
        [
          _c(
            "transition-group",
            _vm._l(_vm.items, function(item) {
              return _c(
                "div",
                { key: item.id, staticClass: "cursor--move list-group-item" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between " },
                    [
                      _c("div", [
                        _vm._v(_vm._s(item.ticket_data.lang.en_GB.title))
                      ])
                    ]
                  )
                ]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.dragging
          ? _c(
              "div",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.submitUpdate }
              },
              [_vm._v("Save order")]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tools d-flex justify-content-end" }, [
      _c("h5", [_vm._v("Drag list item")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05b07738", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b07738","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/lists/RearrangeOrderList.vue
// module id = 387
// module chunks = 0